export default __webpack_public_path__ + "static/media/press-12.a3567f66.jpg";